import { http } from "@/utils/index";

/**
 * 视频中心API接口（展示端）
 */

// 查询上架视频列表
export function getOnShelfVideos(params) {
  return http.request("get", "/video/onshelf", {
    params,
  });
}

// 查询精选视频
export function getFeaturedVideos(size) {
  return http.request("get", "/video/featured", {
    params: { size },
  });
}

// 根据分类查询视频
export function getVideosByCategory(category, size) {
  return http.request("get", `/video/category/${category}`, {
    params: { size },
  });
}

// 根据ID查询视频详情
export function getVideoById(id) {
  return http.request("get", `/video/${id}`, {});
}

// 点赞视频
export function likeVideo(id) {
  return http.request("post", `/video/${id}/like`, {});
}
